export default __webpack_public_path__ + "static/media/polygonlogo.97ff139c.svg";